module.exports = __webpack_public_path__ + "img/translationeditor_6.7de1c241.jpg";